import { AssetListActionTypes, FetchInitAssetsAction, FETCH_INIT_ASSETS, SetCurrentPageAssetsAction, SetPageSizeAssetsAction, SET_CURRENT_PAGE_ASSETS, SET_PAGE_SIZE_ASSETS, StartLoadingAssetsAction, START_LOADING_ASSETS, UpdateAssetsAction, UpdateQueryAssetsAction, UpdateSearchAssetsAction, UpdateSortByAssetsAction, UPDATE_ASSETS, UPDATE_QUERY_ASSETS, UPDATE_SEARCH_ASSETS, UPDATE_SORTBY_ASSETS } from "./assetListActionAndReducerTypes";
import { StartLoadingActionPayload, AssetListState, UpdateAssetsActionPayload } from "./rootReducerTypes";


// #region actions
export function updateAssets(updateAssetsActionPayload: UpdateAssetsActionPayload): UpdateAssetsAction {
    return {
        type: UPDATE_ASSETS,
        updateAssetsActionPayload,
    };
}

export function startLoading(startLoadingActionPayload: StartLoadingActionPayload): StartLoadingAssetsAction {
    return {
        type: START_LOADING_ASSETS,
        startLoadingActionPayload,
    };
}

export function fetchInit(): FetchInitAssetsAction {
    return {
        type: FETCH_INIT_ASSETS,
    };
}
export function setCurrentPage(currentPage: number): SetCurrentPageAssetsAction {
    return {
        type: SET_CURRENT_PAGE_ASSETS,
        currentPage
    };
}
export function setPageSize(pageSize: number): SetPageSizeAssetsAction {
    return {
        type: SET_PAGE_SIZE_ASSETS,
        pageSize
    };
}
export function updateQuery(lastQuery: string): UpdateQueryAssetsAction {
    return {
        type: UPDATE_QUERY_ASSETS,
        lastQuery
    };
}

export function updateSortBy(payload: string): UpdateSortByAssetsAction {
    return {
        type: UPDATE_SORTBY_ASSETS,
        sortBy: payload
    };
}

export function updateSearchAssets(payload: string): UpdateSearchAssetsAction {
    return {
        type: UPDATE_SEARCH_ASSETS,
        searchText: payload
    };
}
// #end region actions


export default function assetListReducer(state: AssetListState = initialState, action: AssetListActionTypes): AssetListState {
    switch (action.type) {
        case 'UPDATE_ASSETS':
            return {
                ...state,
                assets: action.updateAssetsActionPayload.assets,
                totalCount: action.updateAssetsActionPayload.totalCount,
                skip: action.updateAssetsActionPayload.skip,
                loading: false,
            };
        case 'START_LOADING_ASSETS':
            return {
                ...state,
                assetlistParameter: action.startLoadingActionPayload,
            };
        case 'FETCH_INIT_ASSETS':
            return {
                ...state,
                loading: true,
            };
        case 'SET_CURRENT_PAGE_ASSETS':
            return {
                ...state,
                currentPage: action.currentPage
            };
        case 'UPDATE_QUERY_ASSETS':
            return {
                ...state,
                lastQuery: action.lastQuery,
            };
        case 'SET_PAGE_SIZE_ASSETS':
            return {
                ...state,
                pageSize: action.pageSize,
            };
        case 'UPDATE_SORTBY_ASSETS':
            return {
                ...state,
                sortBy: action.sortBy,
            };
        case 'UPDATE_SEARCH_ASSETS':
            return {
                ...state,
                searchText: action.searchText,
            };
        default:
            return state;
    }
}

export const initialState: AssetListState = {
    assets: [],
    skip: 0,
    assetlistParameter: { requestedSkip: 0, take: 20 },
    totalCount: 0,
    loading: false,
    lastQuery: '',
    currentPage: 0,
    pageSize: 50,
    sortBy: '',
    searchText: ''
};